/**
 * 验证类方法集
 * */
import reg from "@/constant/regExp.js";
import { IDPROVINCECODE } from "@/constant/enum.js";

export default {
  // 是否手机
  isMobile(str) {
    return reg.mobilePhone.test(str);
  },
  // 是否电话
  isPhone(str) {
    return reg.phoneNumber.test(str);
  },
  // 是否400电话
  is400(str) {
    return reg.phoneNumber400.test(str);
  },
  // 是否联系方式
  isContact(str) {
    // 号码检测
    return this.isMobile(str) || this.isPhone(str) || this.is400(str);
  },
  // 是否邮箱
  isEmail(str) {
    return reg.email.test(str);
  },
  isIP(str) {
    return reg.IP.test(str);
  },
  // 是否中文
  isCNChar(val) {
    return reg.chinese.test(val);
  },
  // 是否为空
  isNull: function(val) {
    if (val == null || val == undefined) {
      return true;
    }
    var str = val.toString();
    if (str.replace(/\s/g, "") == "" || str == "null" || str == "undefined") {
      return true;
    }
    return false;
  },
  // 是否空对象
  isEmptyObject: function(obj) {
    return this.isObject(obj) && Object.keys(obj).length == 0;
  },
  // 是否空数组
  isEmptyArray: function(list) {
    return this.isArray(list) && list.length == 0;
  },
  // 是否为数值字符串
  isNumberString(str) {
    if (this.isNull(str)) {
      return false;
    }
    return !Number.isNaN(Number(str));
  },
  // 是否为数组
  isArray: function(obj) {
    return Array.isArray(obj);
    // return Object.prototype.toString.call(obj) === '[object Array]'
  },
  // 属否为对象
  isObject: function(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
  },
  isString (obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
  },
  isAliPay: function() {
    return (
      /AliApp/i.test(navigator.userAgent) ||
      /AlipayClient/i.test(navigator.userAgent)
    );
  },
  isWechatBrowser: function() {
    return /MicroMessenger/.test(navigator.userAgent);
  },
  /**
   * 是否身份证号码
   * @param {
   *      code: 15 | 18 位身份证号
   *      sex: 0（女） | 1（男） 性别 （选填）严格验证时填写
   * }
   */
  isIDCard(code, sex = null) {
    var tip = "";
    var pass = true;
    if (!code || !reg.ID.test(code)) {
      tip = "身份证号格式错误";
      pass = false;
    } else if (!IDPROVINCECODE[code.substr(0, 2)]) {
      tip = "地址编码错误";
      pass = false;
    } else {
      let sexCode = code.substr(-1, 1);
      if (code.length == 18) {
        sexCode = code.substr(-2, 1);
        code = code.split("");
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        if (parity[sum % 11] != code[17]) {
          tip = "校验位错误";
          pass = false;
        }
      }
      if (!this.isNull(sex) && sexCode % 2 != sex) {
        tip = "性别错误";
        pass = false;
      }
    }
    return pass;
  },
  isBankCardID(code) {
    // 银行卡号
    return reg.BankCardID.test(code);
  },
  isLuhnCheck(code) {
    // 卡号luhn验证，只做提示不做正确性判断
    if (!this.isBankCardID(code)) {
      return false;
    }
    let arr = [...code].reverse();
    let odd = 0;
    let even = 0;
    for (let i = 0; i < arr.length; i++) {
      if (i % 2 == 1) {
        // 偶数
        if (arr[i] * 2 > 9) {
          odd += arr[i] * 2 - 9;
        } else {
          odd += arr[i] * 2;
        }
      } else {
        // 奇数
        even += arr[i] * 1;
      }
    }
    if ((odd + even) % 10) {
      return false;
    }
    return true;
  },
  isThereThisValue(list, val) {
    if (!this.isArray(list)) {
      return;
    }
    for (let item of list) {
      if (item === val) {
        return true;
      }
    }
    return false;
  }
};
